import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent
} from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';

interface Meta {
  code: string;
  error: string;
  metadata: Record<string, string | number | boolean | Array<string> | Array<number> | Array<boolean>> | null;
}

export const apiErrorMessageInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {

  /**
   * Test if the request URL contains the pattern: /api/rest/public/project/{projectId}
   * The replace is applied globally for all API endpoints and all methods.
   */
  /*
  const method = request.method;
  const url = request.url;
  const pattern = /\/api\/rest\/public\/project\/[^/]+(\?.*)?$/;
  const matches = pattern.test(url);
  */

  const replacedEnumRoleValues = [
    { from: 'OWNER', to: 'Owner' },
    { from: 'ADMIN', to: 'Admin' },
    { from: 'BASIC_USER', to: 'Basic User' },
    { from: 'READ_ONLY', to: 'Read Only' },
    { from: 'NO_ACCESS', to: 'Developer/Guest' }
  ];

  return next(request).pipe(
    map((event: HttpEvent<unknown>) => {
			return event;
		}),
    catchError((event) => {
      /**
       * Replace all occurrences of 'from' with 'to' in the relevant places.
       */
      replacedEnumRoleValues.forEach(({ from, to }) => {
        const eventMessage = event?.message;
        if (eventMessage) {
          const newMessage = eventMessage.replace(new RegExp(from, 'g'), to);
          event.message = newMessage;
        }
        const originalErrorMessage = event?.originalError?.error?.error?.message;
        if (originalErrorMessage) {
          const newMessage = originalErrorMessage.replace(new RegExp(from, 'g'), to);
          event.originalError.error.error.message = newMessage;
        }
        const originalErrorMeta = event?.originalError?.error?.error?.meta as Meta[];
        if (originalErrorMeta && originalErrorMeta?.length > 0) {
          originalErrorMeta.forEach((metaItem) => {
            const metaError = metaItem?.error;
            if (metaError) {
              const newMessage = metaError.replace(new RegExp(from, 'g'), to);
              metaItem.error = newMessage;
            }
          });
        }
      });
      return throwError(() => event);
    })
  )

}
